// extracted by mini-css-extract-plugin
export default {"name":"HddYk","highlight":"u_FCv","otherWords":"bc2jU"};